import http from './http'
import Resource from './resource'

const path = 'admin/domains'

class Domains extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const DomainsRequest = new Domains(http)

export default DomainsRequest
